import { createAction, props } from '@ngrx/store';
import { QuestionClient } from '../../../core/models/question-client/question-client.model';

export const loadQuestionClientRecords = createAction('[Question Client Facade] Load Question Client Records');
export const loadQuestionClientRecordsSuccess = createAction(
    '[Question Client Effects] Load Question Client Records Success',
    props<{ questionClientRecords: Array<QuestionClient> }>()
);
